"use client";

import HighlightSVG from "../../../../../public/static/images/highlight.svg";

interface HighlightTextProps {
  className?: string;
  text: string;
  highlightText?: string | string[];
  textColor?: string;
  highlightTextColor?: string;
  backgroundHighlightColor?: string;
  fontWeight?: number;
}

export default function HighlightText({
  className,
  text,
  highlightText,
  textColor = "inherit",
  highlightTextColor = "inherit",
  backgroundHighlightColor = "currentColor",
  fontWeight = 600,
}: HighlightTextProps) {
  if (!highlightText) {
    return (
      <div style={{ color: textColor, lineHeight: 1.6 }} className={className}>
        {text}
      </div>
    );
  }

  const highlights = Array.isArray(highlightText) ? highlightText : [highlightText];
  const matches: { text: string; start: number; end: number }[] = [];

  highlights.forEach((phrase) => {
    const regex = new RegExp(
      phrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
      "gi"
    );
    let match;
    while ((match = regex.exec(text)) !== null) {
      matches.push({
        text: match[0],
        start: match.index,
        end: match.index + match[0].length,
      });
    }
  });

  matches.sort((a, b) => a.start - b.start);

  const parts: (string | { text: string; highlight: true })[] = [];
  let lastIndex = 0;
  for (const m of matches) {
    if (m.start > lastIndex) parts.push(text.slice(lastIndex, m.start));
    parts.push({ text: m.text, highlight: true });
    lastIndex = m.end;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));

  return (
    <div
      style={{
        lineHeight: 1.6,
        fontSize: "md",
        maxWidth: "70ch",
        fontWeight: "inherit",
        isolation: "isolate",
      }}
      className={className}
    >
      {parts.map((part, i) =>
        typeof part === "string" ? (
          <span key={i} style={{ color: textColor }}>
            {part}
          </span>
        ) : (
          <span
            key={i}
            style={{
              position: "relative",
              display: "inline-block",
              color: highlightTextColor,
              fontWeight,
            }}
          >
            {part.text}
            <HighlightSVG
              style={{
                position: "absolute",
                top: "12%",
                left: "-0.6em",
                right: "-0.6em",
                width: "calc(100% + 1.2em)",
                height: "80%",
                fill: backgroundHighlightColor,
                transform: `rotate(${(Math.random() * 5 - 2.5)}deg)`,
                zIndex: -1,
                pointerEvents: "none",
              }}
            />
          </span>
        )
      )}
    </div>
  );
}
